import { sessionStorageService } from 'services/storage'
const DEFAULT_CURRENCY_VALUE = '1000'

export const validateCurrencyValue = (): string => {
  const storageValue = sessionStorageService.getItem('preactCalculatorInputValue')
  return Number(storageValue) === 0 || storageValue === undefined ? DEFAULT_CURRENCY_VALUE : storageValue
}
